import {
  TOP_UP_POST, 
  PROMISE_PENDING,
  PROMISE_REJECTED,
  PROMISE_FULFILLED,
  TOP_UP_HISTORY
} from '../constants';
import error from '../utils/error';

/*
type Actions = {
  type: string,
  payload: {
    message: string,
    status_code: number,
    data: Object
  }
}
*/

const initialState = {
  topUp:{
    status_code:0,
    message: '',
    isSubmit:false,
    error:null
  },
  pengisian: {
    isFetch: false,
    dataPengisian: [],
    error: null,
    status_code: null,
    last_page: null,
    current_page: null,
    per_page: null,
    total: null
  }
}

const walletHistory = (state, {data: { data, last_page, current_page, per_page, total }, status_code}) => {
  let newState = {
    ...state,
    pengisian: {
      ...state.pengisian,
      isFetch: false,
      dataPengisian: [...data],
      status_code: 200,
      last_page,
      current_page,
      per_page,
      total
    }
  }

  return newState
}

const _incHistoryPayment = (state, {data: {current_page, data, last_page}, ascDesc}) => {
  window.scrollTo(0, 0)
  let newState
  let sortData = {
    ...state,
    pengisian: {
      ...state.pengisian,
      isFetch: false,
      dataPengisian: [...state.pengisian.dataPengisian, ...data],
      current_page,
      last_page,
    }
  }
}


const applyTopUp = (state = initialState, action) => {
  switch (action.type) {
    case `${TOP_UP_POST}${PROMISE_PENDING}`:
      return {...state, topUp:{...state.topUp, isSubmit:true}}
    case `${TOP_UP_POST}${PROMISE_FULFILLED}`:{
      const { status_code, message, data } = action.payload
      return {...state, topUp:{...state.topUp, ...data, status_code, message, isSubmit:false, error:null}}
    }
    case `${TOP_UP_POST}${PROMISE_REJECTED}`:{
      // const { status_code, message } = action.payload.response.data.error;
      return {...state, topUp:{...state.topUp, isSubmit:false,...error(action.payload)}}
    }
    case `${TOP_UP_HISTORY}${PROMISE_PENDING}`:
      return ({
        ...state, "pengisian": {...state.pengisian, isFetch: true}
      });
    case `${TOP_UP_HISTORY}${PROMISE_FULFILLED}`:
      return (walletHistory(state, action.payload));
    case `${TOP_UP_HISTORY}${PROMISE_REJECTED}`:
      return ({
        ...state, pengisian: {...state.pengisian, isFetch: false, error: {...action.payload.response.data.error}}
      });

    default: return state;
  }
}



export default applyTopUp;